import { render, staticRenderFns } from "./address-sucess.vue?vue&type=template&id=9e899f2a&scoped=true"
import script from "./address-sucess.vue?vue&type=script&lang=ts"
export * from "./address-sucess.vue?vue&type=script&lang=ts"
import style0 from "./address-sucess.vue?vue&type=style&index=0&id=9e899f2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e899f2a",
  null
  
)

export default component.exports